import "../../lib/entities/models.js"

Pixlee.module('Entities', function(Entities, App, Backbone, Marionette, $) {
    Entities.DisplayOptions = Entities.DeepModel.extend();
});
